<template>
    <ButtonIcon
        v-b-tooltip.hover.noninteractive.bottom
        icon="filter"
        :title="$t('restoreFiltersToTheDefaultSettings')"
        class="btn-reset-filters"
        variant="light"
        v-bind="$attrs"
        v-on="$listeners"
    />
</template>



<script>
    export default {
        name: 'ButtonResetFilters',
        data() {
            return {};
        },
    };
</script>



<style lang="scss" scoped>
    .btn-reset-filters {
        width: 40px;
        height: 40px;
        padding: 0.25rem;
        border-radius: 50%;
    }
</style>
